module.exports = __webpack_public_path__ + "static/media/target.c06cd925.svg";